export function projectVmRoute(projectKey: string) {
  return {
    to: "/projects/$projectKey/vm" as const,
    params: { projectKey },
  };
}
